import request from '@/utils/request'

// 查询客户 CPE 清单
export function findCpes(params) {
  return request({
    url: `/customer/cpes`,
    method: 'get',
    params
  })
}

export function findCustomerCpeModelOptions(params) {
  return request({
    url: `/customer/cpe_models/options`,
    method: 'get',
    params
  })
}
